import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

import useCampaignMutations from "../../datahooks/useCampaignMutations";

interface DeleteCampaignProps {
  campaignName: string;
  campaignId: string;
  onClose: () => void;
  onCancel: () => void;
}

export default function DeleteCampaign({
  campaignName,
  campaignId,
  onClose,
  onCancel,
}: DeleteCampaignProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { deleteCampaign, isDeletingCampaign } = useCampaignMutations();
  const { relativeNavigate } = useWorkspaceNavigate();

  function onDelete() {
    deleteCampaign({ campaignId }).then(() => {
      onClose();
      relativeNavigate("campaigns");
    });
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Delete Campaign</Title>

      <Description className="mb-8">
        Are you sure you want to delete campaign &quot;
        {campaignName}
        &quot;?
      </Description>

      <div className="flex items-center justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          onClick={onCancel}
          className="lg:flex-1"
          disabled={isDeletingCampaign}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          className="lg:flex-1"
          onClick={onDelete}
          isLoading={isDeletingCampaign}
        >
          Delete
        </Button>
      </div>
    </>
  );
}
